import CrossIcon from '@atlaskit/icon/glyph/cross';
import { ModalHeader } from '@atlaskit/modal-dialog';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

interface Props {
  recognitionSchedule?: {
    availablePoints?: number | null;
    timeUntilRefresh?: number | null;
  } | null;
  onClose: () => void;
}

export const KudosModalHeader = ({ recognitionSchedule, onClose }: Props) => {
  return (
    <ModalHeader>
      <div>
        <div css={giveRecognitionHeaderContainer}>
          <h3 css={giveRecognitionHeaderStyle}>{'Give recognition'}</h3>
          {recognitionSchedule?.availablePoints !== undefined && (
            <div css={recognitionInfoContainer}>
              <p css={giveRecognitionHeaderSubtitle}>
                {`${recognitionSchedule.availablePoints} left this week`}
              </p>
            </div>
          )}
        </div>
        <button type="button" css={closeButtonStyles} onClick={onClose}>
          <CrossIcon
            label="Close Modal"
            size="large"
            primaryColor={token('color.text')}
          />
        </button>
      </div>
    </ModalHeader>
  );
};

const closeButtonStyles = css({
  position: 'absolute',
  right: '16px',
  top: '24px',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  borderRadius: '4px',
});

const giveRecognitionHeaderStyle = css({
  color: '#000',
  fontFamily: token('font.family.brand.heading'),
  fontWeight: token('font.weight.semibold'),
  lineHeight: token('space.500'), // 40px
  fontSize: token('space.400'), //32px
});

const giveRecognitionHeaderContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.100'),
});

const giveRecognitionHeaderSubtitle = css({
  fontWeight: token('font.weight.regular'),
  fontSize: token('space.200'),
  lineHeight: token('space.300'),
  margin: 0,
  color: token('color.text.subtle'),
});

const recognitionInfoContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.050'),
});
